import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, DATETIME, ITEM } from '@/plugins/sdk/fields'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Lead from '@/plugins/sdk/resources/Account/Lead'

export default class extends Resource {
  static name = 'account_lead_incumbent_carrier'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      carrier: new ITEM(Carrier),
      lead: new ITEM(Lead)
    }
  }
}
